module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "file_005"
    }
  }, [_vm._v("contents")])]), _c('a', {
    attrs: {
      "id": "file_005"
    }
  }), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "id": "file_005"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_007#file_007"
    }
  }, [_vm._v("introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_011#file_011"
    }
  }, [_vm._v("materials")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_023#file_023"
    }
  }, [_vm._v("basic techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('strong', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_031#file_031"
    }
  }, [_vm._v("bug magnets")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_047#file_047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("penguin & chick")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_078#file_078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("butterfly pin")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_090#file_090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("bunny")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_105#file_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("owl")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_134#file_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("goldfinch")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_154#file_154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("turtle")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_176#file_176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("bat")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_189#file_189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chicken & chicks")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_212#file_212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("hummingbird")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_232#file_232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("clownfish")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_244#file_244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chipmunk")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_269#file_269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("border collie")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_298#file_298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("cat")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_320#file_320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("frog")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_345#file_345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("sheep")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_375#file_375",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pink pig")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_400#file_400",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("giraffe")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_435#file_435",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("mermaid")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_470#file_470",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("gnome girl")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_509#file_509",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("gallery")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_516#file_516",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("resources")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_517#file_517",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("about the author")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_518#file_518",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("acknowledgment")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39e017d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_005.vue
// module id = 66
// module chunks = 0